$(document).ready(function () {
  $(".hs-fieldtype-checkbox").on("click", function (e) {
    e.preventDafault();
    console.log("Clicked");
    $(this).parent().toggleClass("active");
  });
});
